// Types based on OpenAPI schema
export interface Country {
  id: number;
  name: string;
  code: string;
  phone_code?: string;
}

export interface State {
  id: number;
  name: string;
  code?: string;
  country_id: number;
  country_code?: string;
}

export interface CountriesResponse {
  success: boolean;
  page: number;
  limit: number;
  total: number;
  items: Country[];
}

export interface StatesResponse {
  success: boolean;
  country: {
    id: number;
    name: string;
    code: string;
  };
  items: State[];
}

export interface ApiError {
  success: false;
  error: string;
  details?: object;
}

// Base URL for the API
const BASE_URL = 'https://moncopieur.cloud-erp.ma';

// Get countries with optional search and pagination
export const getCountries = async (params?: {
  search?: string;
  limit?: number;
  page?: number;
}): Promise<CountriesResponse> => {
  const searchParams = new URLSearchParams();
  
  if (params?.search) {
    searchParams.append('search', params.search);
  }
  if (params?.limit) {
    searchParams.append('limit', params.limit.toString());
  }
  if (params?.page) {
    searchParams.append('page', params.page.toString());
  }

  const url = `${BASE_URL}/ws/countries${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  
  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch countries');
  }

  return data;
};

// Get states by country ID
export const getStates = async (countryId: number): Promise<StatesResponse> => {
  const url = `${BASE_URL}/ws/states?country_id=${countryId}`;
  
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  
  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch states');
  }

  return data;
};